import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  static LANGUAGES = ['en', 'es'];
  static DEFAULT_LANG = 'en';
  static DEFAULT_CULTURE_LANG = 'en-US';
  static currency = 'USD';

  constructor(
    private translate: TranslateService,
    private storage: Storage
  ) { }

  getLanguage() {
    const browserLang = this.translate.getBrowserLang();
    return browserLang.match(/en|es/) ? browserLang : SettingsService.DEFAULT_LANG;
  }

  getLanguageAndCountry() {
    const browserLang = this.translate.getBrowserCultureLang();
    return browserLang.match(/en-US|en-GB|es-ES/) ? browserLang : SettingsService.DEFAULT_CULTURE_LANG;
  }

  getCurrency() {
    this.storage.get('inv_currency').then(res => {
      if (res !== null) {
        SettingsService.currency = res;
      }
    });
  }

  setCurrency(currency: string) {
    SettingsService.currency = currency;
    this.storage.set('inv_currency', currency);
  }

}
